import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "createRejectionCodeSet";
export var useCreateRejectionCodeSet = function () {
    var dispatch = useDispatch();
    var createdRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var creatingRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorCreateRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var createRejectionCodeSet = function (body) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "POST",
            path: "/billing/Api/V1/RejectionCodes",
            body: body,
            // extraHeaders: getRejectionCodesUserIdHeader(),
        }));
    };
    var clearCreateRejectionCodeSet = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        createRejectionCodeSet: createRejectionCodeSet,
        clearCreateRejectionCodeSet: clearCreateRejectionCodeSet,
        createdRejectionCodeSet: createdRejectionCodeSet,
        creatingRejectionCodeSet: creatingRejectionCodeSet,
        errorCreateRejectionCodeSet: errorCreateRejectionCodeSet,
    };
};
